import { IWidgetDefinition, IWidget, IWidgetSettings } from '../../common/core';
import { ListData, IListSettings, IListState } from '../list.widget/list';
import ListWidgetDefinition from '../list.widget/list';

var template = require("./fuse-list.html");
var styles = require("./fuse-list.scss").toString();

export interface IFuseListState extends IListState {
    /**
     * AI enabled
     */
    aiMode?: boolean;
}


export interface IFuseListSettings extends IListSettings {
    debug?: true;

    /**
     * Show AI toggle and enable AI UI elements if toggle enabled
     */
    aiToggle?: true;
}

/**
* Settings for fuse-list
*/
export interface IFuseListWidgetSettings extends IWidgetSettings<IFuseListSettings, IFuseListState> {
  type: "fuse-list"
}

class FuseListData extends ListData {

    hasFilters: boolean;
    searchTerm: string;
    aiSuggestion: {
        answer: string;
        link: string;
    }

    constructor(public widget: IWidget<FuseListData, IFuseListSettings, IFuseListState>) {
        super(widget);

        var labels = {
            aiResponsePillLabel: 'AI-generated response may be inaccurate or misleading. Please verify with sources.'
        };

        this.labels = { ...this.labels, ...labels, ...this.widget.settings.labels };
    }

    getSearchWidget(): any {
        var res = null;
        this.widget.service.getAllWidgets().forEach(function (w) {
            switch (w.type) {
                case 'fuse-search':
                    res = w;
                    break;
            }
        });
        return res;
    }

    getFiltersWidget(): any {
        var res = null;
        this.widget.service.getAllWidgets().forEach(function (w) {
            switch (w.type) {
                case 'fuse-subfilters':
                    res = w;
                    break;
            }
        });
        return res;
    }

    beforeSearch(): void {
        super.beforeSearch();

        var searchW = this.getSearchWidget();
        var subfiltersW = this.getFiltersWidget();
        this.hasFilters = subfiltersW?.data.getFilters().length;
        this.searchTerm = searchW?.state?.searchString;
    }

    clearFilters() {
        var subfiltersW = this.getFiltersWidget();
        subfiltersW.data.clearFilters();
    }

    clearSearchTerm() {
        var searchW = this.getSearchWidget();
        searchW.state.searchString = null;
        this.widget.service.setState();
    }

    trackAction(item) {
        var cfg = this.widget.service.getConfig();
        if (cfg.trackAction && this.widget.service.getGlobalOptions()['tracker']) {
            cfg.trackAction('fuse-list:itemClick', this.widget, {
                item: item
            });
        }
    }

    isDebugMode() {
        return this.widget.settings.debug && this.widget.service.getGlobalOptions().source == 'editor';
    }

    onData(response: any): void {
        super.onData(response);

        if (this.widget.s.g['enhanced_search'] && response.ai_results?.qa?.answer) {
            var aiSuggestion = {
                answer: response.ai_results.qa.answer,
                link: response.ai_results.qa.link
            };
            this.aiSuggestion = aiSuggestion;
        } else {
            this.aiSuggestion = null;
        }

        if (response.series) {
            response.series.forEach(function (s) {
                if (s.fields && s.fields.nested_responses_obj) {
                    var replies = s.fields.nested_responses_obj.filter(function (r) {
                        return r.type == "reply";
                    });
                    s.fields._replies = replies;
                }
            });
        }
    }

    toggleAIMode() {
        if (!this.widget.state.aiMode) {
            delete this.widget.state.aiMode;
        }
        this.widget.s.setState(true);
    }

    getSeriesDescription(series, fields) {
        if (this.widget.settings.aiToggle === true && this.widget.state.aiMode === true) {
            if (series.fields.ai_title) {
                return series.getFieldHtmlWithHighlight('ai_title');
            }
        }
        return this._getSeriesDescription(series, fields);
    }
    _getSeriesDescription(series, fields) {
        if (!fields) {
            fields = ['custom_description', 'description'];
        }

        for (var i = 0; i < fields.length; i++) {
            var f = fields[i];
            if (series.fields[f]) {
                var h = series.getFieldHtmlWithHighlight('description');
                if (h.length) {
                    return h;
                }
                else {
                    return series.fields[f];
                }
            }
        }
    }

    trackAIrating(item, thumb) {
        // Need to prevent multiple clicks. If user spam clicks thumbs up/down ???

        if (item._feedback === thumb) {
            return;
        }

        item._feedback = thumb;

        var cfg = this.widget.service.getConfig();
        if (cfg.trackAction && this.widget.service.getGlobalOptions()['tracker']) {
            cfg.trackAction('fuse:custom', this.widget, {
                trackerAction: 'trackFeedbackClick',
                eventBody: {
                    feedback: thumb,
                    description: item.fields.description
                }
            });
        }

        // What if multiple users rate this result?
        console.log(item.series_id);
        console.log(thumb);
    }

    dtToMonthDayYear(dt) {
        if (!dt) {
            return dt;
        }
        var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var dtarr = dt.split(/[- :T]/);
        if (dtarr.length >= 3) {
            var date = new Date(dtarr[0], parseInt(dtarr[1]) - 1, dtarr[2]);
        } else {
            return '';
        }
        return monthNames[date.getMonth()].substr(0, 3) + ' ' + date.getDate() + ', ' + date.getFullYear();
    }

    pluginMore(series) {
        var w = this.widget;
        if (!series._morePlugin) {
            series._morePlugin = {
                _refreshAttr: function (plugin) {
                    var el = plugin.$element.nativeElement;
                    el.setAttribute('data-sj-more', el.scrollHeight > el.clientHeight);
                },
                afterViewChecked: function (plugin) {
                    var self = this;
                    if (!this._init) {
                        this._subs = w.s['resizeSubject'].subscribe(function (width) {
                            self._refreshAttr(plugin);
                        });
                    }

                    this._refreshAttr(plugin);
                },
                onDestroy: function (plugin) {
                    if (this._subs && this._subs.unsubscribe) {
                        this._subs.unsubscribe();
                    }
                }
            };
        }
        return series._morePlugin;
    }

    toggleReplies(s) {
        var w = this.widget;
        s._showReplies = !s._showReplies;

        var f = s.fields || {};
        var cfg = w.service.getConfig();
        if (cfg.trackAction && w.service.getGlobalOptions()['tracker']) {
            cfg.trackAction('trackRepliesShow', w, {
                trackerAction: 'trackRepliesShow',
                eventBody: {
                    label: f.custom_description || f.description || '',
                    type: s._showReplies ? 'expand' : 'collapse'
                }
            });
        }
    }
}

var fuseWidgetDefinition: IWidgetDefinition<FuseListData, IFuseListSettings, null> = Object.assign(
    {},
    ListWidgetDefinition,
    {
        init(widget) {
            widget.data = new FuseListData(widget);
        },
        getFields(widget) {
            var fields = ListWidgetDefinition.getFields(widget);
            if (widget.data.isDebugMode()) {
                var res = ['_score'];
                if (fields) {
                    res.push(<any>fields);
                }
                return res.join(',');
            }
            return fields;
        },
        template: template,
        styles: styles
    });
export default fuseWidgetDefinition;